export default __webpack_public_path__ + "static/media/production-img-1.3c351c30.png";